export default [
  {
    path: '/payResult',
    name: 'PayResult',
    component: () => import('@/views/pay/payResult.vue'),
  },
  {
    path: '/activityRules',
    name: 'ActivityRules',
    component: () => import('@/views/pay/activityRules.vue'),
  },
]
